import useSkin from "./useSkin";

/**
 * Returns a helper that prefixes routes with /griffle when in the Griffle skin.
 * Usage: const { path } = useSkinPath(); <Link to={path("/library")}>
 */
const useSkinPath = () => {
  const { isGriffle } = useSkin();

  const path = (route: string) => (isGriffle ? `/griffle${route}` : route);

  return { path, isGriffle };
};

export default useSkinPath;
